/**
 * Pure helper: get ImageData from a canvas (main-thread only).
 * Used by fragment detection to decouple from UI; easy to test with canvas mock.
 *
 * @param {HTMLCanvasElement|object} canvas - Canvas element or object with getContext, width, height
 * @returns {ImageData}
 */
export function getImageDataFromCanvas(canvas) {
    if (!canvas || typeof canvas.getContext !== 'function') {
        throw new Error('Invalid canvas')
    }
    const ctx = canvas.getContext('2d')
    if (!ctx || typeof ctx.getImageData !== 'function') {
        throw new Error('Canvas 2d context or getImageData not available')
    }
    return ctx.getImageData(0, 0, canvas.width, canvas.height)
}
